import { render, staticRenderFns } from "./corScreen.vue?vue&type=template&id=40892403&scoped=true&"
import script from "./corScreen.vue?vue&type=script&lang=js&"
export * from "./corScreen.vue?vue&type=script&lang=js&"
import style0 from "./corScreen.vue?vue&type=style&index=0&id=40892403&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40892403",
  null
  
)

export default component.exports